import { TrustBadgeVariableItem } from "@intelligems/ig-types/dtos/checkout-blocks";

export const ensureBlockItemOrder = <T extends TrustBadgeVariableItem>(
  items: T[]
): T[] => {
  return items.map((item, index) => {
    return {
      ...item,
      order: index,
    };
  }) as T[];
};
